/**
 * Register client connected apps
 */
import ReactOnRails from "react-on-rails";
import {
  PianoLoginProvider as PianoLogin,
  PrimaryCtaProvider as PrimaryCta,
  SubscriberContentProvider as SubscriberContent
} from "react-piano-manager";

import AppClient from "./client";

// Store
import store from "../store";

ReactOnRails.registerStore({ store });

ReactOnRails.register({ AppClient });

ReactOnRails.register({ PianoLogin });
ReactOnRails.register({ PrimaryCta });
ReactOnRails.register({ SubscriberContent });
